import styled from 'styled-components';
import posed from 'react-pose';

export const Error = styled(
  posed.div({
    preEnter: {
      opacity: 0
    },
    enter: {
      opacity: 1,
      transition: { duration: 400 }
    },
    exit: {
      opacity: 0,
      transition: { duration: 400 }
    }
  })
)`
  font-size: 16px;
  color: #d56262;

  @media (min-width: 1000px) {
    font-size: 18px;
  }
`;
